type GAEventProperties = {
  [key: string]: string | number | boolean | null;
};

export const GAEvent = (action: string, eventProperties: GAEventProperties) => {
  window.gtag('event', action, eventProperties);
};
